import { render } from "./StafetDonationTaendLysFlow.vue?vue&type=template&id=e967e27e"
import script from "./StafetDonationTaendLysFlow.vue?vue&type=script&lang=js"
export * from "./StafetDonationTaendLysFlow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__